<template>
  <q-card flat>
    <q-card-section class="no-padding">
      <q-banner class="bg-blue text-white" inline-actions>
        <span>بارنامه های من</span>
        <template v-slot:action>
          <q-btn rounded color="indigo"
                 text-color="white" icon="attach_money"
                 @click="showFinanceInfo"
                 label="مشاهده کارت معین"
                 v-if="$store.state.roles.some(v=>['user_driver'].includes(v)) && false"/>
        </template>
      </q-banner>
    </q-card-section>
    <q-card-section class="text-center">
      <q-chip square icon="local_shipping"
              v-for="(item, index) in [...new Set(this.items.filter(v=>v.WayBillNumber).map(v => v.WayBillNumber))]"
              :key="index"
              clickable
              @click="wayBillDetailData(item)"
              :label="item"/>
    </q-card-section>
    <q-separator/>
    <q-card-section horizontal class="q-ma-md"
                    v-if="selectedItem &&
                        items.filter(item => item.WayBillNumber === selectedItem) &&
                        items.filter(item => item.WayBillNumber === selectedItem).length>0 &&
                        !items.filter(item => item.WayBillNumber === selectedItem)[0].ActualSendDatetime">
      <span class="vertical-middle text-subtitle2 q-mr-sm">فاکتورهای بارنامه</span> <span
        class="text-bold text-indigo">{{ selectedItem }}</span>
      <span class="q-ml-xs">به مبلغ</span>
      <span
          class="text-bold text-amber-10 q-ml-xs">{{
          items.filter(item => item.WayBillNumber === selectedItem)[0].TransferCost.toLocaleString()
        }}</span>
      <span class="q-ml-xs">ریال</span>

    </q-card-section>
    <q-card-section class="no-padding">
      <span v-if="$store.state.roles.some(v=>['admin'].includes(v)) &&
              items.filter(item => item.WayBillNumber === selectedItem) &&
              items.filter(item => item.WayBillNumber === selectedItem).length>0" class="q-ml-mdn">متعلق به </span>
      <span v-if="$store.state.roles.some(v=>['admin'].includes(v)) &&
              items.filter(item => item.WayBillNumber === selectedItem) &&
              items.filter(item => item.WayBillNumber === selectedItem).length>0"
            class="q-ml-xs text-bold text-indigo"> {{
          items.filter(item => item.WayBillNumber === selectedItem)[0].Visitor_Name
        }}</span>
    </q-card-section>

    <q-card-actions align="right" v-if="selectedItem &&
                        items.filter(item => item.WayBillNumber === selectedItem) &&
                        items.filter(item => item.WayBillNumber === selectedItem).length>0 &&
                        !items.filter(item => item.WayBillNumber === selectedItem)[0].ActualSendDatetime">
      <q-btn class="float-right" size="sm" color="red" flat label="انصراف" @click="selectedItem=undefined"/>
      <q-btn class="float-right" size="sm" color="indigo" text-color="white" label="حرکت کردم"
             @click="goToDistination"/>
    </q-card-actions>
    <q-card-section class="text-center"
                    v-if="selectedItem &&
                        items.filter(item => item.WayBillNumber === selectedItem) &&
                        items.filter(item => item.WayBillNumber === selectedItem).length>0 &&
                        items.filter(item => item.WayBillNumber === selectedItem)[0].ActualSendDatetime">
      <span class="text-h5 vertical-middle">فاکتورهای بارنامه</span>
      <span class="text-h5 text-bold text-indigo">{{ selectedItem }}</span>
      <span v-if="$store.state.roles.some(v=>['admin'].includes(v))" class="q-ml-xs text-h5">متعلق به </span>
      <span v-if="$store.state.roles.some(v=>['admin'].includes(v))" class="q-ml-xs text-bold text-indigo text-h5"> {{
          items.filter(item => item.WayBillNumber === selectedItem)[0].Visitor_Name
        }}</span>
      <q-separator/>
      <div class="text-h6">
        <span>تاریخ و زمان حرکت </span>
        <span dir="ltr" class="text-red text-bold">
                {{ items.filter(item => item.WayBillNumber === selectedItem)[0].ActualSendDatetime | toJalaliDateTime }}
                </span>
      </div>
      <q-separator/>
    </q-card-section>
    <q-card-section v-if="selectedItem">
      <div class="q-gutter-none" v-for="item in items.filter(rec=> rec.WayBillNumber === selectedItem)"
           :key="item.Sale_Num">
        <q-btn
            v-if="selectedItem &&
                        items.filter(rec => rec.WayBillNumber === selectedItem) &&
                        items.filter(rec => rec.WayBillNumber === selectedItem).length>0 &&
                        items.filter(rec => rec.WayBillNumber === selectedItem)[0].ActualSendDatetime"
            icon="check"
            round
            color="green"
            :disable="inProcess"
            flat class="q-mr-sm"
            @click="setReceive(item)"/>
        <q-chip color="brown" text-color="white" :label="item.Factor_Num" square icon="shopping_basket">
          <q-tooltip>
            شماره فاکتور
          </q-tooltip>
        </q-chip>
        <q-chip :label="item.Cs_Name" square icon="person" clickable @click="showCustomerInfo(item)"/>
      </div>
    </q-card-section>

    <q-dialog
        v-model="showFinanceInfoDialog"
        :maximized="$q.screen.lt.md">
      <CustomerFinanceInfo :customer-info="selectedCustomer"/>
    </q-dialog>

    <q-dialog
        v-model="showCustomerInfoDialog"
        :maximized="$q.screen.lt.md">
      <CustomerInfo :general-info-only="true" :buy-list="false" :dialog="true" :selected-customer="selectedCustomer"/>
    </q-dialog>
  </q-card>
</template>

<script>
import {mapActions} from "vuex";
import CustomerFinanceInfo from "@/components/customers/CustomerFinanceInfo.vue";
import CustomerInfo from "@/components/customers/CustomerInfo.vue";

export default {
  name: "DriverOwnRemittance",
  components: {CustomerInfo, CustomerFinanceInfo},
  data() {
    return {
      items: [],
      selectedItem: undefined,
      wayNumbers: [],
      showFinanceInfoDialog: false,
      selectedCustomer: undefined,
      showCustomerInfoDialog: false,
      inProcess: false
    }
  },
  methods: {
    ...mapActions({
      getData: 'Drivers/getRemittanceList',
      setActualDateTime: 'Drivers/setActualTransfer',
      setActualReceiveDateTime: 'Drivers/setActualTransferForSaleExi',
      getFinanceInfo: 'Users/getUsersInfoForFinanceInfo',
      getCustomerInfo: 'Customers/get_customer_info_by_code'
    }),
    showFinanceInfo() {
      this.getFinanceInfo(this.$store.state.userId).then((res) => {
        this.selectedCustomer = res[0]
        this.showFinanceInfoDialog = true
      })
    },
    showCustomerInfo(item) {
      this.getCustomerInfo(item.Cs_Code).then((res) => {
        this.selectedCustomer = res.data[0]
        this.showCustomerInfoDialog = true
      })
    },
    removeFromList(item) {
      this.setActualDateTime(item).then(() => {
      })
    },
    wayBillDetailData(selected) {
      this.selectedItem = selected
    },
    goToDistination() {
      this.setActualDateTime(this.selectedItem).then((res) => {
        if ('result' in res.data) {
          const foundedList = this.items.filter(item => item.WayBillNumber === this.selectedItem)
          foundedList.forEach(rec => rec.ActualSendDatetime = JSON.parse(res.data.result)[0].ActualSendDatetime)
          this.$q.notify({
            type: 'positive',
            position: 'top',
            color: 'positive',
            message: 'تاریخ و زمان حرکت ثبت شد'
          })
        }
      })
    },
    setReceive(rowInfo) {
      this.inProcess = true
      const wayBillNumber = this.items.filter(v => v.Sale_Num === rowInfo.Sale_Num)[0].WayBillNumber

      this.setActualReceiveDateTime({
        Sale_Num: rowInfo.Sale_Num,
        issueFinance: false,
        wayBillNumber: wayBillNumber
      }).then((res) => {
        if ('result' in res.data) {
          const index = this.items.findIndex(item => {
            return (rowInfo.Sale_Num === item.Sale_Num)
          })
          this.$delete(this.items, index)
          this.$q.notify({
            type: 'positive',
            position: 'top',
            color: 'positive',
            message: 'اقلام فاکتور به مشتری تحویل داده شد'
          })
          if (res.data.issueFinance !== -1) {
            this.$q.notify({
              type: 'positive',
              position: 'top',
              color: 'positive',
              message: 'سند حسابداری صادر شد'
            })
          }
        }
        this.inProcess = false
      }).catch(() => this.inProcess = false)
    }
  },
  created() {
    this.getData(0).then((res) => {
      this.items = res.data
      this.items.forEach(rec => rec.selected = false)
    })
  }
}
</script>

<style scoped>

</style>